import { Button } from '@progress/kendo-react-buttons'
import * as React from 'react'
import { connect } from 'react-redux'
import { Label, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import * as App from '../../../app'
import { FlashMessage } from '../../../components/flash-message';
import * as IsActive from '../../../components/is_active'
import { Loading } from '../../../components/loading'
import * as RasaModal from '../../../components/modal'
import * as RasaInput from '../../../components/rasa-input'
import {DateFilter} from '../date-filter'
import * as Types from '../types'
import * as Actions from './actions'
import * as Constants from './constants'
import './styles.css'

interface StateProps {
  app: App.State,
  router: any,
  contentCalendar: Types.FullComponentState,
}
interface DispatchProps {
  closeModal: RasaModal.Close
  onSubmit: Types.SubmitEmailActionCreator,
  update: Types.SelectEmailActionCreator
}
type Props = StateProps & DispatchProps

const SendEmailModal = ({app, router, contentCalendar, closeModal, onSubmit, update}: Props) => {
  return (
  <div>
    <Modal isOpen={contentCalendar.modal.isOpen}>
    <ModalHeader toggle={closeModal}>Send Test</ModalHeader>
      <ModalBody>
      <div className="field">
        <Label className="field-label">Filter Date</Label>
        <DateFilter />
      </div>
      <div className="flash">
      <FlashMessage />
      </div>
      {contentCalendar.view.sendStatus === Constants.CONTENT_FAILURE ?
      <div className="cutoff">
        <IsActive.FilterSelect filterState={contentCalendar.view.selectedCutoff}
                               filters={Constants.selectedCutoffFilters}
                               event={Constants.CHANGE_CUTOFF_DATE}
                               />
      </div>
      : null}
      <div className="field">
        <RasaInput.RasaInput label="Email Address"
                             validation={contentCalendar.data.validation}
                             type="textarea"
                             placeholder="Enter a valid email address."
                             helpType="send-email"
                             value={contentCalendar.data.emailString}
                             onChange={(e: React.ChangeEvent<HTMLInputElement>) => update(e.target.value)} />
      </div>
      </ModalBody>
      <ModalFooter>
        {contentCalendar.modal.isSubmitting ? <Loading center size={Loading.Sizes.MEDIUM} /> :
        <Button primary={true}
                disabled={RasaInput.selectInvalid(contentCalendar.data.validation)}
                onClick={() =>
                contentCalendar.view.sendStatus === Constants.CONTENT_FAILURE ?
                onSubmit(app.selectedCommunity,
                         contentCalendar.data,
                         contentCalendar.view.selectedCutoff.value,
                         router.pathname)
                : onSubmit(app.selectedCommunity, contentCalendar.data, null, router.pathname)
                }>
                Send Test
        </Button> }
        <Button look="outline" onClick={closeModal}>Cancel</Button>
      </ModalFooter>
    </Modal>
  </div>
  )
}

export const SendEmailModalConnected = connect(
  ({app, router, contentCalendar}: StateProps) => ({app, router, contentCalendar}),
  {
    closeModal: Actions.toggleModal,
    onSubmit: Actions.sendEmail,
    update: Actions.updateEmailAddress,
  },
)(SendEmailModal)



// WEBPACK FOOTER //
// ./src/pages/content-calendar/send-email-modal/component.tsx